@if (tour.active()) {
  <div class="gt-layer" role="dialog" aria-modal="true" aria-label="Guided tour">

    @if (spot(); as s) {
      <!-- The ring's giant box-shadow paints the dim around the cutout. -->
      <div class="gt-spot"
        [style.top.px]="s.top" [style.left.px]="s.left"
        [style.width.px]="s.width" [style.height.px]="s.height"></div>
    } @else {
      <div class="gt-dim"></div>
    }

    @if (tour.current(); as step) {
      <div #tipCard class="gt-card"
        [class.gt-card--center]="!spot()"
        [class.gt-card--placed]="placed()"
        [style.top.px]="spot() ? tipPos()?.top : null"
        [style.left.px]="spot() ? tipPos()?.left : null"
        role="document" aria-labelledby="gt-title">

        <div class="gt-card__head">
          <span class="gt-card__count">{{ tour.index() + 1 }} of {{ tour.steps().length }}</span>
          <button type="button" class="gt-card__close" (click)="tour.skip()" aria-label="Close tour">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <h3 class="gt-card__title" id="gt-title">{{ step.title }}</h3>
        <p class="gt-card__body">{{ step.body }}</p>

        <div class="gt-card__foot">
          <button type="button" class="gt-skip" (click)="tour.skip()">Skip tour</button>
          <div class="gt-dots" aria-hidden="true">
            @for (s of tour.steps(); track $index) {
              <span class="gt-dot" [class.gt-dot--active]="$index === tour.index()"></span>
            }
          </div>
          <div class="gt-nav">
            @if (tour.index() > 0) {
              <button type="button" class="gt-btn gt-btn--ghost" (click)="tour.back()">Back</button>
            }
            <button type="button" class="gt-btn gt-btn--primary" (click)="tour.next()">
              {{ tour.isLast() ? 'Done' : 'Next' }}
            </button>
          </div>
        </div>

      </div>
    }

  </div>
}
